import { forwardRef } from 'preact/compat'
import { useState, useEffect } from 'preact/hooks'
import { globalState, localeSearchUrl } from '@/components/helpers/utils'

const MOBILE_QUERY = '(max-width: 1023px)'

const DESKTOP_PLACEHOLDER =
  globalState.search.searchDropdownPlaceholder || 'Search our range by colour, style, material...'
const MOBILE_PLACEHOLDER =
  globalState.search.searchDropdownPlaceholderMobile || 'Search our range...'

export const SearchInput = forwardRef(({ onInput, redirect }, ref) => {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' && window.matchMedia(MOBILE_QUERY).matches
  )

  useEffect(() => {
    if (typeof window === 'undefined') return
    const mql = window.matchMedia(MOBILE_QUERY)
    const handleChange = (event) => setIsMobile(event.matches)
    setIsMobile(mql.matches)
    mql.addEventListener('change', handleChange)
    return () => mql.removeEventListener('change', handleChange)
  }, [])

  return (
    <input
      ref={ref}
      onInput={onInput}
      className="grow field-input paragraph-m lg:paragraph-xs p-0 border-0 focus:border-0"
      type="text"
      name="query"
      placeholder={isMobile ? MOBILE_PLACEHOLDER : DESKTOP_PLACEHOLDER}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault()
          if (redirect) {
            window.location.href = redirect
          } else {
            window.location.href = localeSearchUrl(e.target.value)
          }
        }
      }}
    />
  )
})
